import React from 'react';
import { IconProps } from '.';

const SvgTruckSetting = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M3.502 8c0-1.37 1.139-2.45 2.5-2.45C7.361 5.55 8.5 6.63 8.5 8s-1.139 2.45-2.499 2.45S3.502 9.37 3.502 8Zm2.5-1.05c-.625 0-1.1.49-1.1 1.05s.475 1.05 1.1 1.05C6.624 9.05 7.1 8.56 7.1 8s-.475-1.05-1.099-1.05Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M4.973 2.25a.999.999 0 0 0-.994.855l-.136.92c-.095.05-.188.104-.278.159l-.915-.358-.006-.002a1.004 1.004 0 0 0-1.228.433L.392 5.98a.992.992 0 0 0 .249 1.3l.002.002.756.575a3.617 3.617 0 0 0 0 .286l-.756.575-.002.002a.998.998 0 0 0-.26 1.282l.005.008 1.03 1.732c.267.464.807.583 1.211.44l.012-.004.924-.361c.091.056.184.11.28.159l.136.919a.999.999 0 0 0 .994.855H7.03a.999.999 0 0 0 .995-.855l.135-.92c.096-.05.188-.104.278-.159l.915.358.006.002c.444.169.974.009 1.229-.433l1.03-1.733.004-.008a.998.998 0 0 0-.26-1.282l-.002-.002-.755-.575a3.727 3.727 0 0 0 0-.286l.755-.575.003-.002a.998.998 0 0 0 .259-1.282l-.005-.008-1.03-1.733c-.266-.463-.807-.582-1.211-.44l-.011.005-.925.361a4.511 4.511 0 0 0-.28-.159l-.135-.919a.999.999 0 0 0-.995-.855H4.973Zm.232 2.822L5.4 3.75h1.203l.194 1.322.402.16c.248.099.479.23.697.394l.334.25 1.277-.5.585.985-1.07.815.055.43c.018.145.03.27.03.394 0 .125-.012.25-.03.394l-.056.43 1.071.815-.585.985-1.272-.497-.332.242a3.231 3.231 0 0 1-.704.4l-.402.16-.194 1.321H5.4l-.195-1.322-.401-.16a3.032 3.032 0 0 1-.697-.394l-.334-.25-1.277.5-.586-.985 1.071-.815-.055-.43A3.124 3.124 0 0 1 2.896 8c0-.12.011-.25.03-.394l.055-.43-1.07-.815.585-.985 1.271.497.332-.242a3.23 3.23 0 0 1 .705-.4l.4-.16Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M14.25 5.75H13v-1.5h2.75v5h4.925l3.075 2.924v5.576h-2.76a3 3 0 1 1-5.98 0h-3.02a3 3 0 1 1-5.98 0H2.25V15h1.5v1.25h2.813A2.996 2.996 0 0 1 9 15c1.004 0 1.892.493 2.437 1.25h2.813V5.75Zm1.5 10.266A2.993 2.993 0 0 1 18 15c1.004 0 1.892.493 2.437 1.25h1.813v-3.433l-2.174-2.067H15.75v5.266ZM10.5 18a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm9 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgTruckSetting;
